import React, { Component } from 'react'
import { connect } from 'react-redux'
import startCase from 'lodash/startCase'
import capitalize from 'lodash/capitalize'
import { History } from 'history'

import { UserBanner } from '../users/userBanner'
import TaskWrapper from './taskWrapper'
import { TaskHeader } from './taskHeader'
import { TaskButtons } from './taskButtons'
import { selectAdminUserIndex } from '../../reducers/adminUsers'
import { fetchAdminList } from '../admin/adminActions'
import { selectTask } from '../../reducers/tasks'
import {
  fetchTask,
  approveTask,
  rejectTask,
  assignTask,
  completeTask,
} from './taskActions'
import { Task } from './types'
import { User } from '../../core/types'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  adminUsers: User[]
  adminUserId: number
  approveTask: Callback<Promise<any>>
  assignTask: Callback<Promise<any>>
  completeTask: Callback<Promise<any>>
  fetchAdminList: Callback
  fetchTask: Callback<Promise<any>>
  rejectTask: Callback<Promise<any>>
  history: History
  match: Match<ParamsID>
  task: Task
  location: Location
}

export class TaskModify extends Component<Props> {
  static displayName = 'TaskModify'
  state = {
    loading: false,
  }

  componentDidMount() {
    const { fetchTask, match, task } = this.props
    const taskId = match.params && match.params.id
    if (taskId && !task.id) {
      this.showLoading()
      fetchTask(taskId)
        .then((res) => {
          this.hideLoading()
          this.fetchAdmins(res)
        })
        .catch(() => {
          this.hideLoading()
        })
    }
    this.fetchAdmins(task.taskType)
    this.checkAssignee()
  }

  showLoading() {
    this.setState({
      loading: true,
    })
  }

  hideLoading() {
    this.setState({
      loading: false,
    })
  }

  fetchAdmins = (taskType: string) => {
    const { fetchAdminList } = this.props
    const badges: string[] = []
    badges.push(taskType)
    fetchAdminList(badges)
  }

  checkAssignee = () => {
    const { task, assignTask, adminUserId } = this.props

    if (task.id && !task.assignee) {
      assignTask(task.id, adminUserId)
    }
  }

  backToIndex = () => {
    this.props.history.goBack()
  }

  rejectOnClick = (): Promise<any> | void => {
    const { rejectTask, task, history, fetchTask } = this.props
    const taskName = capitalize(startCase(task.taskType || ''))
    if (window.confirm(`Confirm ${taskName} rejection`)) {
      this.showLoading()
      return rejectTask(task.id)
        .then(() => {
          fetchTask(task.id).then(() => {
            this.hideLoading()
            history.goBack()
          })
        })
        .catch(() => {
          this.hideLoading()
        })
    }
  }

  approveOnClick = () => {
    const { approveTask, task, history } = this.props
    this.showLoading()
    return approveTask(task.id)
      .then(() => {
        this.hideLoading()
        history.goBack()
      })
      .catch(() => {
        this.hideLoading()
      })
  }

  completeOnClick = () => {
    const { completeTask, task, history } = this.props
    this.showLoading()
    return completeTask(task.id)
      .then(() => {
        this.hideLoading()
        history.goBack()
      })
      .catch(() => {
        this.hideLoading()
      })
  }

  generateUrl = (task) => {
    switch (task.entityType) {
      case 'REFI':
        return `/refinance/${task.entityId}`
      default:
        return null
    }
  }

  reassignTask = (assigneeId) => {
    const { adminUserId, assignTask, task, history } = this.props
    const formatAssigneeId = assigneeId === 'null' ? null : assigneeId

    return assignTask(task.id, formatAssigneeId).then(() => {
      if (adminUserId.toString() !== formatAssigneeId) {
        history.goBack()
      }
    })
  }

  render() {
    const { adminUsers, task } = this.props
    if (!task) return null
    const { assignee, pendingAt, status, taskType, title, user, vehicle } = task
    const pageTitle = capitalize(startCase(title || taskType || ''))
    const taskStatus = capitalize(startCase(status || ''))
    return pageTitle ? (
      <div className="task-modify">
        <UserBanner
          user={user}
          context="Task"
          wrapperClass="task-modify__banner"
        />
        <div className="task-modify__body">
          <TaskHeader
            taskStatus={taskStatus}
            vehicle={vehicle}
            pageTitle={pageTitle}
            assignee={assignee}
            adminUsers={adminUsers}
            pendingAt={pendingAt}
            task={task}
            link={this.generateUrl(task)}
            reassignTask={this.reassignTask}
          />
          <div>
            <TaskWrapper
              task={task}
              history={this.props.history}
              location={this.props.location}
            />
          </div>
          <div className="task-modify__buttons">
            <TaskButtons
              isLoading={this.state.loading}
              task={task}
              complete={this.completeOnClick}
              approve={this.approveOnClick}
              reject={this.rejectOnClick}
              back={this.backToIndex}
            />
          </div>
        </div>
      </div>
    ) : (
      <div className="task-load">
        <div className="task-load__top-loading">
          <div className="task-load__title-loading">
            <h2>Loading...</h2>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, { match }) => {
  return {
    adminUserId: state.session.user.id,
    adminUsers: selectAdminUserIndex(state.adminUsers),
    task: selectTask(state.tasks, match.params.id),
  }
}

export default connect(mapStateToProps, {
  fetchAdminList,
  fetchTask,
  approveTask,
  rejectTask,
  assignTask,
  completeTask,
})(TaskModify)
